import { Component, OnInit, inject } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ECustomerOrganizationStatus} from '@app/shared/enums/header.enum';
import {ICountry} from '@app/shared/models/countrylanguage.model';
import {selectCustomerOrganizationStatus} from '@app/shared/state/header/header.selector';
import {Store} from '@ngrx/store';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {SelectModule} from 'primeng/select';
import {Subject, takeUntil, tap} from 'rxjs';
import {LanguageSelectorComponent} from '../language-selector/language-selector.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [TranslateModule, RouterModule, SelectModule, FormsModule, LanguageSelectorComponent],
})
export class FooterComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly store = inject(Store);

  countries: ICountry[] = [];
  selectedCountry: ICountry;
  copyrightText = '';

  private readonly unsubscribe$ = new Subject<void>();
  isActiveAccount = false;

  constructor() {
    this.countries = [
      {name: 'Germany', code: 'DE'},

      {name: 'Romania', code: 'RO'},
    ];
    this.selectedCountry = this.countries[0];
  }

  ngOnInit(): void {
    this.getCopyright();
    this.initCustOrgStatus();
  }

  getCopyright() {
    this.translate.get('Footer.Copyright').subscribe((data: string) => {
      const copyright = data.replace('{year}', new Date().getFullYear().toString());
      this.copyrightText = copyright;
    });
  }

  private initCustOrgStatus(): void {
    this.store
      .select(selectCustomerOrganizationStatus)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(accStatus => {
          this.isActiveAccount = accStatus === ECustomerOrganizationStatus.Active;
        })
      )
      .subscribe();
  }
}
